import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalExtended} from 'ngx-dynamic-modal';
import {VnaCallerIdService} from '../../services/vna-caller-id.service';
import {AuthService} from '../../../../../core/service/auth.service';

@Component({
  selector: 'app-caller-ids-file-upload',
  templateUrl: './caller-ids-file-upload.component.html',
  styleUrls: ['./caller-ids-file-upload.component.scss']
})
export class CallerIdsFileUploadComponent extends ModalExtended implements OnInit {

  form: FormGroup;
  file: File;
  errors = {};

  enclosureTypes: Array<Object> = [];
  delimiterTypes: Array<Object> = [];

  submitted = false;
  enabled = false;
  result: any;

  constructor(private fb: FormBuilder, private callerIdService: VnaCallerIdService, private auth: AuthService) {

    super();
    this.form = this.fb.group({
      enclosure: new FormControl(''),
      delimiter: new FormControl(''),
      vna_client_pk: new FormControl('', Validators.required),
      service_campaign_verification_pk: new FormControl('', Validators.required)
    });

    this.enclosureTypes=[
      {value: "DOUBLE_QUOTE", label: 'Double Quote '+ '( \" )'},
      {value: "SIMPLE_QUOTE", label: 'Single Quote '+'( \' ) ' },
      {value: "EMPTY", label: 'Empty'}
    ];

    this.delimiterTypes=[
      {value: ";", label: 'Dot and comma' + ' ( ; )' },
      {value: ",", label: 'Comma' + ' ( , )' },
      {value: "TAB", label: 'Tab' + ' ( )' },
      {value: "|", label:'Pipe' + ' ( | )' },
      {value: "~|~", label: 'Special type'+ ' ( | )' }
    ];
  }

  onAction(event): void {
    (event.currentFiles.length > 0)
      ? this.file = event.file
      : this.file = null
    ;
  }

  onExit() {
    this.applyCallback({});
    this.close();
  }

  loadFile(): void {

    this.submitted = false;
    this.result = {};

    if(!this.form.valid || !this.file){
      this.submitted = true;
      return;
    }

    let formData: FormData = new FormData();
    const formValue: any = this.form.value;
    for (let key of Object.keys(formValue)){
      formData.append(key, formValue[key]);
    }

    formData.append('portal', this.auth.getPortalSelected().getPortal());
    formData.append('file', this.file, this.file.name);
    this.enabled = true;
    this.callerIdService.postCallerIdsFile(formData).subscribe(
      (result: any) => {
        this.result = result;
        this.enabled = false;
      }
    )
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/modals/caller-ids-file-upload/caller-ids-file-upload.component.ts